// src/utils/PrivateRoute.js
import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = () => {
  const { loading, isAuthenticated, validateAuthAndLogout } = useContext(AuthContext);

  // Show loading spinner while auth state is initializing
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Validate authentication and logout if invalid
  const authValid = validateAuthAndLogout();

  // Check if user is properly authenticated with valid tokens
  const authenticated = authValid && isAuthenticated();

  return authenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;